import { cs, MuiImage, useIsDesktop } from "@repo/ui";
import bannerImage from "@repo/ui/assets/images/novel-banner-no-coin.png";
import { type FC } from "react";
import * as Styled from "./PensionBanner.styled";

export const PensionBanner: FC = () => {
    const IsDesktop = useIsDesktop();

    return (
        <Styled.BannerWrapper>
            {IsDesktop && (
                <Styled.ImageContainer>
                    <MuiImage src={bannerImage} alt="Potvrzení o odeslání změny" />
                </Styled.ImageContainer>
            )}

            <Styled.ContentContainer>
                <Styled.HeadingContainer>
                    {cs.pensionBanner.textLine11}
                    <Styled.HighlightedText>{cs.pensionBanner.textLine12}</Styled.HighlightedText>
                    <Styled.InlineText>{cs.pensionBanner.textLine13}</Styled.InlineText>
                </Styled.HeadingContainer>
            </Styled.ContentContainer>

            <Styled.ButtonContainer spacing={3}>
                <Styled.StyledButton
                    onClick={() => {
                        window.open(
                            "https://www.nn.cz/online-sjednani-penzijniho-sporeni.html?utm_source=prihlaseni.nn.cz&utm_medium=referral&utm_campaign=new-contract",
                            "_blank",
                        );
                    }}
                >
                    {cs.pensionBanner.getMoreInfo}
                </Styled.StyledButton>
            </Styled.ButtonContainer>
        </Styled.BannerWrapper>
    );
};
